const formContainer = document.querySelector('.wpforms-container')
const newsletterBlock = document.querySelector('.block--banner-form-newsletter')

const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if the target node (added node) is the desired element
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const addedElement = mutation.addedNodes[0];
        setTimeout(function() {
            const elHeight = addedElement.offsetHeight;
            newsletterBlock.style.height = elHeight+'px';
        }, 100);
        
        observer.disconnect(); // Stop observing after the element is added
      }
    });
});

if (formContainer) {
observer.observe(formContainer, { childList: true });
}

function handleResize(){
    const confBlock = document.querySelector('.wpforms-confirmation-container-full')
    let updHeight = 0
    if(confBlock && newsletterBlock) {
        updHeight = confBlock.offsetHeight
        newsletterBlock.style.height = updHeight+'px';
    }
}

window.addEventListener('resize', handleResize);

handleResize();

// disable invalid event form subs
var eventForm = document.querySelector('#event-registration-form');
if(eventForm && !window.isValidEvent) {
  eventForm.style.display = 'none';
}